import { useState } from 'react';
import { Copy, CopyCheck } from 'lucide-react';
import { copyToClipboard } from '../utils/clipboard';
import styles from './CopyableCode.module.css';

interface CopyableCodeProps {
  value: string;
}

export function CopyableCode({ value }: CopyableCodeProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    const success = await copyToClipboard(value);
    if (success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <span className={styles.wrapper}>
      <code className={styles.code}>{value}</code>
      <button
        type="button"
        className={styles.copyBtn}
        onClick={handleCopy}
        title="Copy reference number"
      >
        {copied ? <CopyCheck size={14} /> : <Copy size={14} />}
        {copied ? 'Copied!' : 'Copy'}
      </button>
    </span>
  );
}
